<template>
  <div class="login">
    <div class="login-container">
      <h2 class="font-white site-title">
        {{$store.getters.sysConfigs['TITLE']}}
      </h2>
      <div class="login-area">
        <div class="login-thumb">
          <h3 class="font-darkgreen">
            {{$store.getters.sysConfigs['TITLE']}}
          </h3>
          <div class="padding-top-20"></div>
          <h2 class="font-darkgreen">
            系统登录
          </h2>
          <div class="padding-top-20"></div>
          <div class="padding-top-20"></div>
          <Button type="default" to="/verify" shape="circle" icon="ios-search" long size="large" style="width: 200px;margin-right:5px">保函验真</Button>
        </div>
        <div class="login-box">
          <Tabs class="login-tabs">
            <TabPane label="账密登录">
              <Form ref="loginForm" :model="loginModel" :rules="ruleValidate" label-position="top">
                <FormItem prop="loginName">
                  <Input v-model="loginModel.loginName"
                    @keyup.enter.native="login"
                    size="large"
                    placeholder="输入用户名">
                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                  </Input>
                </FormItem>
                <FormItem prop="password">
                  <Input v-model="loginModel.password"
                    @keyup.enter.native="login"
                    size="large"
                    type="password" placeholder="输入密码">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </Input>
                </FormItem>
                <FormItem prop="captcha">
                  <Input v-model="loginModel.captcha"
                    size="large"
                    @keyup.enter.native="login"
                    placeholder="图形验证码" style="width:140px" />
                  <img :src="captchaImg" v-if="captchaImg" style="cursor:pointer;vertical-align:middle;margin-left:5px" @click="getCaptcha" />
                </FormItem>
                <div class="login-btns">
                  <Button type="primary" size="large" shape="circle" long style="width: 200px;margin-right:5px" @click="login" :disabled="loading">登录</Button>
                  <Button type="default" size="large" shape="circle" long style="flex: 1" to="/forget-password">忘记密码</Button>
                </div>
                <div class="padding-top-20"></div>
              </Form>
            </TabPane>
            <TabPane label="CA登录">
              <CertSelectModal
                :show="showCertSelectModal"
                :dataSigning="loginData"
                @cert-verified="certLoginSigned"
                @close-modal="showCertSelectModal=false" />
              <Alert show-icon>
                <!-- 插入CA证书设备 -->
                <Icon type="md-key" slot="icon"></Icon>
                <template slot="desc">
                  请插入指定的CA证书设备后点击下方按钮(请使用IE10+,Edge,Chrome,360等浏览器)
                  <a href="./static/TopESA/CA驱动&插件.zip">CA插件下载</a>
                </template>
              </Alert>
              <p class="text-center">
                <Button type="primary" shape="circle" size="large" long style="width:200px;height:60px;margin:20px auto" @click="loginWithCert" :disabled="loading">CA登录</Button>
              </p>
            </TabPane>
            <TabPane label="短信登录" v-if="$store.getters.sysConfigs['ENABLE_SMS_LOGIN']">
              <Form ref="loginMobileForm" :model="loginMobileModel" :rules="ruleMobileValidate" label-position="top">
                <FormItem prop="mobile">
                  <Input v-model="loginMobileModel.mobile"
                    @keyup.enter.native="login"
                    placeholder="手机号">
                    <Icon type="ios-phone-portrait" slot="prepend"></Icon>
                  </Input>
                </FormItem>
                <FormItem prop="sms">
                  <Input v-model="loginMobileModel.sms"
                    @keyup.enter.native="login"
                    placeholder="输入验证码">
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                    <Button slot="append" @click="sendSms" :disabled="smsCoolingDown>0">{{smsCoolingDown>0?smsCoolingDown+'秒后可重新获取':'获取验证码'}}</Button>
                  </Input>
                </FormItem>
                <div class="login-btns">
                  <Button type="primary" shape="circle" size="large" long @click="loginSms" :disabled="loading">登录</Button>
                </div>
              </Form>
            </TabPane>
          </Tabs>
          <div class="verify">
            <a @click="showNewUserModal=true" v-if="$store.getters.sysConfigs['ENABLE_REGISTER']" style="display:inline-block;float:left">注册新用户</a>
            <router-link to="/published" v-if="$store.getters.sysConfigs['SHOW_PUBLISHED_GUARANTORS']" style="color:#999;margin-right:10px"> 保证人备案名录</router-link>
          </div>
        </div>
      </div>
      <Footer class="footer" :style="{padding: '5px 0px', color: '#ccc', fontSize: '12px'}" />
    </div>
    <!-- <div id="floadAD" class="fload-ad" v-if="$configs('showPublishedGuarantors')">
      <a class="close text-right" href="javascript:void();" style="display:block;background:#e2e2e2;color:#333">×关闭</a>
      <router-link class="item" title='保证人备案合格名录' to="/published" target="_blank">
        <img src="./../assets/floatwindow01.png" alt="保证人备案合格名录" />
      </router-link>
    </div> -->
    <NewUserModal :show="showNewUserModal" @on-close="showNewUserModal=false" />
  </div>
</template>

<script>
import Api from './../api/Api'
import CertSelectModal from './../components/CertSelectModal'
import NewUserModal from './Users/AddInModal'
import Footer from '@/components/Footer'
export default {
  name: 'login',
  components: {
    CertSelectModal,
    NewUserModal,
    Footer
  },
  data () {
    return {
      loginModel: {
        loginName: '',
        password: '',
        passwordMd5: '',
        captcha: ''
      },
      loginMobileModel: {
        mobile: '',
        sms: ''
      },
      ruleValidate: {
        loginName: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请填写验证码', trigger: 'blur' }
        ]
      },
      ruleMobileValidate: {
        mobile: [
          { required: true, message: '请填写手机号码', trigger: 'blur' }
        ],
        sms: [
          { required: true, message: '请填写验证码', trigger: 'blur' }
        ]
      },
      captchaImg: '',
      loading: false,
      accountApi: null,
      smsCoolingDown: 0,
      cdTask: null,
      showCertSelectModal: false,
      loginData: null,
      showNewUserModal: false
    }
  },
  created () {
    // let bgImageUrl = require(this.$configs('welcomeBakcgroundImageUrl'))
    // console.log(document.querySelector('.login'), this.$store.getters.sysConfigs('welcomeBakcgroundImageUrl'))
  },
  mounted () {
    this.$store.getters.sysConfigs['WELCOME_BACKGROUND_IMAGE_URL'] ? document.querySelector('.login').style.backgroundImage = `url(${require('@/assets/bg_02.jpg')})` : null
    this.getCaptcha()
    // this.floatAd('#floadAD')
  },
  methods: {
    async getCaptcha () {
      await Api.Auth(this).getCaptcha().then((img) => {
        this.captchaImg = img
      })
    },
    async sendSms () {
      clearInterval(this.cdTask)
      if (!this.loginMobileModel.mobile) {
        this.$Notice.error({
          title: '请填写手机号'
        })
        return false
      }
      await Api.Auth(this).sendSmsCode(this.loginMobileModel.mobile).then(() => {
        this.$Message.success('短信已发送')
        this.smsCoolingDown = 60
        this.cdTask = setInterval(() => {
          if (this.smsCoolingDown > 0) {
            this.smsCoolingDown -= 1
          } else {
            clearInterval(this.cdTask)
          }
        }, 1000)
      }).catch(err => {
        this.$Notice.error({
          title: '发送验证码失败',
          desc: err.message
        })
      })
    },
    async login () {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.loginModel.passwordMd5 = this.$md5(this.loginModel.password)
          await Api.Auth(this).login(this.loginModel)
          .then((payload) => {
            // console.log(payload)
            window.localStorage.setItem('token', payload)
            this.$Message.success('登陆成功!')
            this.loading = false
            this.$Spin.hide()
            Api.Auth(this).getMyDetail().then((data) => {
              this.$store.dispatch('setUserInfo', data)
              window.localStorage.setItem('userInfo', JSON.stringify(data))
            })
            this.$router.push({path: '/dashboard'})
          })
          .catch(err => {
            this.loading = false
            this.$Spin.hide()
            this.$Notice.error({
              title: '登陆失败!',
              desc: err.message
            })
            this.getCaptcha()
            this.loginModel.captcha = null
          })
        }
      })
    },
    async loginSms () {
      this.$refs.loginMobileForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Auth(this).loginViaSms(this.loginMobileModel)
          .then((payload) => {
            // console.log(payload)
            window.localStorage.setItem('token', payload)
            this.$Message.success('登陆成功!')
            this.loading = false
            this.$Spin.hide()
            Api.Auth(this).getMyDetail().then((data) => {
              this.$store.dispatch('setUserInfo', data)
              window.localStorage.setItem('userInfo', JSON.stringify(data))
            })
            this.$router.push({path: '/dashboard'})
          })
          .catch(err => {
            this.loading = false
            this.$Spin.hide()
            this.$Notice.error({
              title: '登陆失败!',
              desc: err.message
            })
          })
        }
      })
    },
    loginWithCert () {
      this.loginData = Math.round(Math.random() * 100000).toString()
      this.showCertSelectModal = true
    },
    async certLoginSigned (certSigned) {
      console.log(certSigned)
      this.$Spin.show()
      await Api.Auth(this).loginViaCert({
        rand: this.loginData,
        certSn: certSigned.certSn,
        sign: certSigned.sign
      }).then((payload) => {
        // console.log(payload)
        window.localStorage.setItem('token', payload)
        this.$Message.success('登陆成功!')
        this.loading = false
        this.$Spin.hide()
        Api.Auth(this).getMyDetail().then((data) => {
          this.$store.dispatch('setUserInfo', data)
          window.localStorage.setItem('userInfo', JSON.stringify(data))
        })
        this.$router.push({path: '/dashboard'})
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '登陆失败!',
          desc: err.message
        })
      })
    },
    floatAd (selector) {
      var obj = document.querySelector(selector)
      if (obj.querySelectorAll('.item').length === 0) return
      var windowHeight = window.innerHeight
      var windowWidth = window.innerWidth
      var dirX = -1.5 // 每次水平漂浮方向及距离(单位：px)，正数向右，负数向左，如果越大的话就会看起来越不流畅，但在某些需求下你可能会需要这种效果
      var dirY = -1 // 每次垂直漂浮方向及距离(单位：px)，正数向下，负数向上，如果越大的话就会看起来越不流畅，但在某些需求下你可能会需要这种效果
                  
      var delay = 30 // 定期执行的时间间隔，单位毫秒
      obj.style.left = windowWidth / 2 - obj.clientWidth / 2 + 'px'
      obj.style.top = windowHeight / 2 - obj.clientHeight / 2 + 'px'
      obj.style.display = 'block'
      var handler = setInterval(move, delay)
      obj.onmouseenter = () => { // 鼠标经过时暂停，离开时继续
        clearInterval(handler)
      }
      obj.onmouseleave = () => {
        handler = setInterval(move, delay)
      }
      obj.querySelector('.close').onclick = () => {
        close()
      }
      function move() {
        var nextPosX = obj.offsetLeft + dirX
        var nextPosY = obj.offsetTop + dirY
        if (nextPosX >= windowWidth - obj.clientWidth) {
          dirX = dirX * -1 // 改变方向
          nextPosX = obj.offsetLeft + dirX
        }
        if (nextPosX <= 0 || nextPosX >= windowWidth - obj.clientWidth) {
          dirX = dirX * -1 // 改变方向
          nextPosX = obj.offsetLeft + dirX
        }
        if (nextPosY <= 0 || nextPosY >= windowHeight - obj.clientHeight - 5) {//如果达到上边，或者达到下边，则改变为相反方向。
          dirY = dirY * -1 // 改变方向
          nextPosY = obj.offsetTop + dirY
        }
        obj.style.left = nextPosX + 'px'
        obj.style.top = nextPosY + 'px'
      }
      function close() {
        clearInterval(handler)
        obj.remove()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  height: 100vh;
  background-color: #f2f2f2;
  overflow: hidden;
  color: #efefef;
  background-image: url('./../assets/01.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .login-container {
    .site-title {
      position: absolute;
      top: 10px;
      left: 20px;
    }
    position: relative;
    z-index: 100;
    padding: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    .login-area {
      background: #fff;
      width: 640px;
      height: 386px;
      border-radius: 20px;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      .login-thumb {
        display: block;
        width: 285px;
        height: 100%;
        background-image: url('./../assets/bg_01_1.png');
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-bottom: 120px;
      }
      .login-box {
        width: 355px;
        padding: 30px 15px 10px 15px;
        background: #fff;
        display: flex;
        flex-direction: column;
        .login-tabs {
          flex: 1;
          .login-btns {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
        }
        .verify {
          text-align: right;
        }
      }
    }
    .ivu-form-item {
      color: #ccc !important;
    }
  }
  
  .footer {
    position: absolute;
    bottom: 5px;
    left: 5px;
  }
}
.fload-ad { position: absolute;z-index: 999900; display: none; }
.fload-ad .item { display: block; }
.fload-ad .item img { vertical-align: bottom; }
</style>
